// extracted by mini-css-extract-plugin
export default {"pageContent":"Insights_pageContent__Hfwsq"};